import dashboardConfig from "./dashboard";
import batchConfig from "./batch";
// import reviewConfig from './review'

export const PortalConfigs = [
  dashboardConfig,
  batchConfig,
  // reviewConfig,
];
